<template>
    <div id="app" style="height: 100%;">
        <router-view />
    </div>
</template>

<script>
import { ForgeMessage, isParentOrigin } from './utils/forgeMessageUtils'
import { updateMarkupsStyle } from './scripts/js/forgeService';
import { drawImage64OnPlane, drawImageOnPlane } from './scripts/js/forgeviewer';
import store from './store';

export default {
    name: 'App',
    created() {
        if (isParentOrigin()) {
            let forgeMessage = new ForgeMessage('get-next-test-blind-sequence', null);
            forgeMessage.send();
        }

        window.updateMarkupsStyle = updateMarkupsStyle;
        window.drawImage64OnPlane = drawImage64OnPlane;
        window.drawImageOnPlane = drawImageOnPlane;

        store.dispatch('GET_DATA_FROM_LOCAL_STORAGE');
    },
    components: {
    }
}
</script>

<style>
@import './styles/main.css';

#app {
    width: 100%;
    height: 100%;
}
</style>
